angular.module("Main").filter("filterBuchungszeitraumBis", function () {
    return function (input, timeTill) {
        var result = [];
        var nowToday = new Date();
        for (let i = 0; i < input.length; ++i) {
            if (input[i].appointment.visible) {
                let BuchungszeitraumDate = new Date(input[i].appointment.Start);
                BuchungszeitraumDate = BuchungszeitraumDate.setHours(BuchungszeitraumDate.getHours() - timeTill);
                if (BuchungszeitraumDate > nowToday) {
                    result.push(input[i])
                }
            } else {
                result.push(input[i])
            }
        }

        return result;
    };
});